var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M4.273 6.378a4 4 0 0 1 4-4h6.064a2 2 0 0 1 1.536.72l3.937 4.724a2 2 0 0 1 .463 1.28v9.276a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M15.273 2.878v3.5a2 2 0 0 0 2 2h2.5M8.273 12.378h8M8.273 17.378h4"
})));
export default SvgReports;